import PropTypes from 'prop-types';

import './index.less';

function Content({ children, hide }) {
  return !hide && <div className="layout__content">{children}</div>;
}

Content.propTypes = {
  children: PropTypes.node,
  hide: PropTypes.bool,
};

export default Content;
